var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrthopatientlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 672,
    height: 249,
    viewBox: "0 0 672 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_748_6984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.2119 105.049C51.0693 105.049 43.6815 103.579 37.0511 100.638C30.4207 97.6981 24.7028 93.724 19.8948 88.7147C15.0893 83.7055 11.3928 78.0643 8.80789 71.7897C6.22035 65.5163 4.92529 59.0498 4.92529 52.3926C4.92529 45.4859 6.29791 38.9068 9.04313 32.6552C11.7858 26.4036 15.6141 20.8224 20.5255 15.9105C25.4343 10.9985 31.2169 7.1191 37.8731 4.27096C44.5268 1.42409 51.7931 0 59.6694 0C67.8146 0 75.2025 1.49701 81.8303 4.48974C88.4607 7.48374 94.1527 11.509 98.9065 16.5669C103.66 21.6247 107.331 27.2775 109.918 33.5239C112.503 39.7717 113.796 46.1755 113.796 52.7368C113.796 59.5987 112.452 66.1548 109.761 72.4064C107.07 78.658 103.267 84.2404 98.3559 89.1523C93.4445 94.0643 87.6749 97.9412 81.0445 100.784C74.4141 103.627 67.1374 105.049 59.2119 105.049ZM26.8225 52.5244C26.8225 56.986 27.5617 61.3004 29.0429 65.4677C30.5215 69.6337 32.6541 73.3391 35.4407 76.5839C38.2273 79.8287 41.6368 82.4056 45.6694 84.3146C49.6993 86.2236 54.2902 87.1781 59.442 87.1781C64.7075 87.1781 69.3656 86.1865 73.4214 84.202C77.4772 82.2175 80.8713 79.5549 83.6062 76.2129C86.341 72.8708 88.4064 69.1296 89.8049 64.9892C91.2033 60.85 91.9038 56.6507 91.9038 52.3926C91.9038 47.9297 91.162 43.6396 89.6834 39.5222C88.2048 35.4048 86.0567 31.7096 83.2391 28.4367C80.4241 25.165 77.0016 22.5996 72.9768 20.7393C68.952 18.8802 64.4154 17.95 59.3696 17.95C54.104 17.95 49.4563 18.9288 45.4238 20.8851C41.3939 22.8428 37.9998 25.4695 35.2416 28.7693C32.4835 32.0679 30.3897 35.7733 28.9628 39.8869C27.5359 44.0004 26.8225 48.2125 26.8225 52.5244Z",
    fill: "url(#paint0_linear_748_6984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.075 104.253V0.664062H211.432C216.594 0.664062 221.338 1.64543 225.662 3.60816C229.987 5.5709 233.738 8.19769 236.92 11.4911C240.102 14.7832 242.565 18.4758 244.315 22.5689C246.063 26.662 246.936 30.8165 246.936 35.0324C246.936 39.4467 246.12 43.6626 244.489 47.6802C242.857 51.6965 240.534 55.2241 237.517 58.2616C234.503 61.2978 230.943 63.6418 226.841 65.2911L252.326 104.253H228.348L205.502 69.4827H183.672V104.253H162.075ZM183.672 51.8885H210.951C213.647 51.8885 216.046 51.1438 218.15 49.6545C220.252 48.1652 221.927 46.1397 223.173 43.5782C224.422 41.0166 225.045 38.1672 225.045 35.0324C225.045 31.7992 224.323 28.9267 222.886 26.4151C221.449 23.9022 219.601 21.9151 217.341 20.4526C215.082 18.9902 212.66 18.2583 210.078 18.2583H183.672V51.8885Z",
    fill: "url(#paint1_linear_748_6984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.086 18.2583H340.473V104.253H318.876V18.2583H283.193V0.664062H376.086V18.2583Z",
    fill: "url(#paint2_linear_748_6984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.223 0.664062V104.253H490.631V60.0887H440.004V104.253H418.407V0.664062H440.004V42.4932H490.631V0.664062H512.223Z",
    fill: "url(#paint3_linear_748_6984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.284 105.049C604.139 105.049 596.751 103.579 590.12 100.638C583.49 97.6981 577.772 93.724 572.967 88.7147C568.161 83.7055 564.465 78.0643 561.877 71.7897C559.29 65.5163 557.997 59.0498 557.997 52.3926C557.997 45.4859 559.37 38.9068 562.112 32.6552C564.857 26.4036 568.683 20.8224 573.595 15.9105C578.506 10.9985 584.289 7.1191 590.942 4.27096C597.596 1.42409 604.862 0 612.739 0C620.884 0 628.272 1.49701 634.902 4.48974C641.53 7.48374 647.222 11.509 651.976 16.5669C656.732 21.6247 660.403 27.2775 662.988 33.5239C665.573 39.7717 666.868 46.1755 666.868 52.7368C666.868 59.5987 665.521 66.1548 662.83 72.4064C660.139 78.658 656.339 84.2404 651.428 89.1523C646.516 94.0643 640.744 97.9412 634.114 100.784C627.486 103.627 620.209 105.049 612.284 105.049ZM579.892 52.5244C579.892 56.986 580.633 61.3004 582.112 65.4677C583.591 69.6337 585.726 73.3391 588.512 76.5839C591.299 79.8287 594.706 82.4056 598.739 84.3146C602.768 86.2236 607.362 87.1781 612.511 87.1781C617.777 87.1781 622.437 86.1865 626.493 84.202C630.546 82.2175 633.94 79.5549 636.675 76.2129C639.41 72.8708 641.476 69.1296 642.874 64.9892C644.272 60.85 644.973 56.6507 644.973 52.3926C644.973 47.9297 644.234 43.6396 642.753 39.5222C641.274 35.4048 639.126 31.7096 636.311 28.4367C633.493 25.165 630.073 22.5996 626.049 20.7393C622.021 18.8802 617.487 17.95 612.441 17.95C607.176 17.95 602.525 18.9288 598.496 20.8851C594.463 22.8428 591.069 25.4695 588.311 28.7693C585.553 32.0679 583.461 35.7733 582.035 39.8869C580.605 44.0004 579.892 48.2125 579.892 52.5244Z",
    fill: "url(#paint4_linear_748_6984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83258 249.219V197.425H29.4565C32.0363 197.425 34.4093 197.917 36.5729 198.901C38.7339 199.885 40.6106 201.199 42.2003 202.843C43.7901 204.486 45.0231 206.332 45.8968 208.378C46.7705 210.424 47.2074 212.505 47.2074 214.622C47.2074 217.539 46.4862 220.313 45.0412 222.946C43.5962 225.579 41.5799 227.719 38.9898 229.365C36.4022 231.012 33.3701 231.835 29.8908 231.835H16.6299V249.219H5.83258ZM16.6299 223.037H29.2161C30.5629 223.037 31.7623 222.694 32.8143 222.007C33.8664 221.319 34.7039 220.335 35.3269 219.054C35.9499 217.773 36.2601 216.29 36.2601 214.606C36.2601 212.829 35.9008 211.313 35.1822 210.057C34.4635 208.8 33.5407 207.847 32.4111 207.197C31.2789 206.547 30.0691 206.222 28.7792 206.222H16.6299V223.037Z",
    fill: "#475E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.844 197.425H136.851L157.381 249.219H146.216L141.067 236.316H121.504L116.432 249.219H105.237L125.844 197.425ZM139.105 229.236L131.348 207.874L123.311 229.236H139.105Z",
    fill: "#475E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.642 206.222H241.834V249.219H231.036V206.222H213.195V197.425H259.642V206.222Z",
    fill: "#475E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.655 197.425H324.857V249.22H335.655V197.425Z",
    fill: "#475E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.488 240.423V249.219H401.744V197.425H439.779V206.222H412.542V218.724H436.062V226.925H412.542V240.423H440.488Z",
    fill: "#475E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.797 215.95V249.219H510V197.425H518.67L547.502 231.53V197.465H558.302V249.219H549.268L520.797 215.95Z",
    fill: "#475E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.456 206.222H654.648V249.219H643.851V206.222H626.01V197.425H672.456V206.222Z",
    fill: "#475E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.086 146.239H0V156.744H672.086V146.239Z",
    fill: "#A1A1A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_748_6984",
    x1: 336.045,
    y1: -34.783,
    x2: 336.045,
    y2: 136.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3282BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_748_6984",
    x1: 336.045,
    y1: -34.7829,
    x2: 336.045,
    y2: 136.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3282BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_748_6984",
    x1: 336.045,
    y1: -34.7829,
    x2: 336.045,
    y2: 136.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3282BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_748_6984",
    x1: 336.045,
    y1: -34.7829,
    x2: 336.045,
    y2: 136.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3282BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_748_6984",
    x1: 336.045,
    y1: -34.783,
    x2: 336.045,
    y2: 136.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3282BB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_748_6984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 672,
    height: 249,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrthopatientlogo);
export default __webpack_public_path__ + "static/media/orthopatientlogo.09f6f2d52e66fe44a9c1c187c5588aaf.svg";
export { ForwardRef as ReactComponent };